import { createFeatureSelector } from '@ngrx/store';
import { EnvironmentReducer, EnvironmentState } from 'src/app/shared/reducers/environment.reducer';
import { ApifonConfigurationReducer, ApifonConfigurationState } from './apifon-configuration.reducer';
import { EnboxConfigurationReducer, EnboxConfigurationState } from './enbox-configuration.reducer';
import {
  IntegrationManagementActionsReducer,
  IntegrationManagementActionsState,
} from './integration-management-actions.reducer';
import { CreateNewIntegrationReducer, CreateNewIntegrationState } from './integration-management-create-new.reducer';
import { SearchReducer, SearchState } from './integration-management-search.reducer';
import { NeverbounceConfigurationReducer, NeverbounceConfigurationState } from './neverbounce-configuration.reducer';
import {
  QcMessageAppConfigurationReducer,
  QcMessageAppConfigurationState,
} from './qc-message-app-configuration.reducer';
import { SesConfigurationReducer, SesConfigurationState } from './ses-configuration.reducer';
import { EliquaCXConfigurationState, EliquaCXConfigurationReducer } from './eliqua-cx.configuration.reducer';
import { OmniConfigurationReducer, OmniConfigurationState } from './omni-configuration.reducer';
export const featureName = 'IntegrationManagement';

export interface DragonflyState {
  environment: EnvironmentState;
  search: SearchState;
  enboxConfiguration: EnboxConfigurationState;
  apifonConfiguration: ApifonConfigurationState;
  neverbounceConfiguration: NeverbounceConfigurationState;
  qcMessageAppConfiguration: QcMessageAppConfigurationState;
  createNewIntegrationManagement: CreateNewIntegrationState;
  integrationManagementActions: IntegrationManagementActionsState;
  sesConfiguration: SesConfigurationState;
  eliquaCXConfiguration: EliquaCXConfigurationState;
  omniConfiguration: OmniConfigurationState;
}

export const moduleReducers = {
  environment: EnvironmentReducer,
  search: SearchReducer,
  enboxConfiguration: EnboxConfigurationReducer,
  apifonConfiguration: ApifonConfigurationReducer,
  neverbounceConfiguration: NeverbounceConfigurationReducer,
  qcMessageAppConfiguration: QcMessageAppConfigurationReducer,
  createNewIntegrationManagement: CreateNewIntegrationReducer,
  integrationManagementActions: IntegrationManagementActionsReducer,
  sesConfiguration: SesConfigurationReducer,
  eliquaCXConfiguration: EliquaCXConfigurationReducer,
  omniConfiguration: OmniConfigurationReducer,
};

export const getDragonflyState = createFeatureSelector<DragonflyState>(featureName);
